import type { Person } from '@crmsy/shared';

const HUES = [18, 32, 140, 205, 265, 330];

function hue(id: string): number {
  let h = 0;
  for (const ch of id) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return HUES[h % HUES.length]!;
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || '?';
}

export function Avatar({ person, id, size = 22 }: { person?: Person; id: string; size?: number }) {
  const name = person?.name ?? '?';
  return (
    <span
      title={name}
      className="inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-white"
      style={{ width: size, height: size, fontSize: size * 0.42, background: `hsl(${hue(id)} 55% 50%)` }}
    >
      {initials(name)}
    </span>
  );
}

export function Owners({ ids, people }: { ids: string[]; people: Person[] }) {
  if (!ids.length) return <span className="text-muted">—</span>;
  return (
    <span className="inline-flex items-center gap-1">
      {ids.map((id) => (
        <Avatar key={id} id={id} person={people.find((p) => p.id === id)} />
      ))}
      {ids.length === 1 && <span className="truncate">{people.find((p) => p.id === ids[0])?.name ?? 'Unknown'}</span>}
    </span>
  );
}
